import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./scss/index.scss";
import { REVIEW_AVATARS } from "@temp/core/config";
import dayjs from "dayjs";
import React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import ReactSVG from "react-svg";
import { Overlay } from "../..";
import { generateCategoryUrl } from "../../../core/utils";
import closeImg from "../../../images/x.svg";
import { RatingStars } from "../../ProductReviews/RatingStars";
export function ReviewItemModal(_ref) {
  var overlay = _ref.overlay;
  var intl = useIntl();
  var _overlay$context$data = overlay.context.data,
      item = _overlay$context$data.item,
      categoryId = _overlay$context$data.categoryId,
      categoryName = _overlay$context$data.categoryName,
      showGallery = _overlay$context$data.showGallery;
  var gallerySliced = item.images.slice(0, 4);
  return React.createElement(Overlay, {
    context: overlay
  }, React.createElement("div", {
    className: "review-item-modal"
  }, React.createElement(ReactSVG, {
    path: closeImg,
    onClick: overlay.hide,
    className: "review-item-modal__close-icon"
  }), React.createElement("div", {
    className: "review-item-modal__review-gallery"
  }, gallerySliced && gallerySliced.map(function (img, i, gallery) {
    return React.createElement("button", {
      type: "button",
      className: "review-item-modal__review-gallery-img",
      key: i,
      onClick: function onClick() {
        return showGallery(gallery, i);
      }
    }, React.createElement("img", {
      src: img.url,
      alt: img.alt
    }), gallerySliced.length > 1 && React.createElement("div", {
      className: "image-count"
    }, item.images.length - 1, "+"));
  })), categoryId && React.createElement("div", {
    className: "review-item-modal__category"
  }, React.createElement("span", {
    className: "review-item-modal__category-title"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Collection:",
    "id": "components.OverlayManager.ReviewItemModal.ReviewItemModal.4159602405"
  }, "id", "components.OverlayManager.ReviewItemModal.ReviewItemModal.4159602405"))), React.createElement(Link, {
    to: "".concat(generateCategoryUrl(categoryId, categoryName))
  }, React.createElement("span", {
    className: "review-item-modal__category-name"
  }, categoryName))), React.createElement("div", {
    className: "review-item-modal__rate"
  }, React.createElement(RatingStars, {
    rating: item.rating
  })), React.createElement("div", {
    className: "review-item-modal__title"
  }, item.title), React.createElement("div", {
    className: "review-item-modal__description"
  }, item.description), React.createElement("div", {
    className: "review-item-modal__extra"
  }, React.createElement("div", {
    className: "review-item-modal__avatar"
  }, React.createElement("img", {
    src: REVIEW_AVATARS.get(item.avatar),
    alt: "avatar"
  })), React.createElement("div", {
    className: "review-item-modal__author"
  }, React.createElement("div", {
    className: "review-item-modal__author-name"
  }, item.fullName), React.createElement("div", {
    className: "review-item-modal__author-date"
  }, dayjs(item.createdAt).format("DD MMM YYYY")))), React.createElement("button", {
    type: "button",
    className: "review-item-modal__close",
    onClick: overlay.hide
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Continue to the website",
    "id": "components.OverlayManager.ReviewItemModal.ReviewItemModal.3674705980"
  }, "id", "components.OverlayManager.ReviewItemModal.ReviewItemModal.3674705980")))));
}